import React, { memo } from "react"

/**
 * Props for the ForgotPasswordButton component.
 */
interface ForgotPasswordButtonProps {
  /**
   * Function to execute when the button is clicked.
   */
  onClick: () => void

  /**
   * Determines whether the button is disabled.
   * Defaults to `false`.
   */
  disabled?: boolean

  /**
   * Optional ID for the button element.
   */
  id: string
}

/**
 * ForgotPasswordButton component renders a small text button
 * that allows users to initiate the password recovery process.
 * It supports optional click handling and a disabled state.
 *
 * @param {ForgotPasswordButtonProps} props - The properties for the ForgotPasswordButton component.
 * @returns {JSX.Element} The rendered forgot password button.
 */
const ForgotPasswordButton: React.FC<ForgotPasswordButtonProps> = memo(
  ({ onClick, disabled, id }) => (
    <button
      data-automation-id={id}
      id={id}
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="ml-auto text-sm text-gray-600 hover:text-red-600 transition-colors disabled:opacity-50"
    >
      Forgot Password?
    </button>
  )
)

export default ForgotPasswordButton
